import {SurveyModel} from 'survey-core';
import Analytics from 'utils/Analytics';
export const STORAGE_ITEM_KEY = 'rise-survey-data';

function clearSurveyData() {
  window.localStorage.removeItem(STORAGE_ITEM_KEY);
}

function readSurveyData() {
  const data = window.localStorage.getItem(STORAGE_ITEM_KEY) ?? null;
  if (data) {
    try {
      return JSON.parse(data);
    } catch (error) {
      console.error('Error reading survey data', error);
      return null;
    }
  }
}

const __resetSurveyData = async (reason: string, survey: SurveyModel) => {
  const surveyData = readSurveyData();
  Analytics.track('Reset Survey Data', {
    previousSurveyTitle: surveyData?.title,
    currentSurveyTitle: survey.title,
    reason,
  });
  clearSurveyData();
};

function saveSurveyData(survey: SurveyModel) {
  const data = survey.data;
  const prevData = readSurveyData() ?? {};

  if (prevData?.title && prevData.title !== survey.title) {
    console.warn('Unable to save survey data, survey title changed');
    return __resetSurveyData('Survey Title Mismatch on Save', survey);
  }

  data.title = survey.title;
  data.pageNo = survey.currentPageNo;
  data.completed = survey.state === 'completed';
  window.localStorage.setItem(STORAGE_ITEM_KEY, JSON.stringify(data));
}

function restoreSurveyData(survey: SurveyModel) {
  const prevData = window.localStorage.getItem(STORAGE_ITEM_KEY) ?? null;
  if (prevData) {
    const data = JSON.parse(prevData);
    const previousSurveyTitle = data?.title;
    const currentSurveyTitle = survey.title;

    if (previousSurveyTitle !== currentSurveyTitle) {
      console.warn('Unable to restore survey data, survey title changed');
      return __resetSurveyData('Survey Title Mismatch on Restore', survey);
    }
    survey.data = data;
    if (data.pageNo) {
      survey.currentPageNo = data.pageNo;
    }
    if (data.completed) {
      survey.completeLastPage();
    }
  }
}

export const SurveyData = {
  clear: clearSurveyData,
  save: saveSurveyData,
  restore: restoreSurveyData,
  read: readSurveyData,
};
